import { responseStatus } from "../constants";
import { ApiPaths } from "../helpers/api";
import intance from "../utils/axios";
import { DonNgoaiGio, ThongTinDonNgoaiGio, TimKiemDonNgoaiGioRequest } from "../models/ngoaigio/DonNgoaiGio";

export const luuDangKyNgoaiGio = async (request: any) => {
    var rs: DonNgoaiGio = new DonNgoaiGio;
    await intance.post(ApiPaths.ngoaiGio.luuDangKyNgoaiGio, request)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const trinhDangKyNgoaiGio = async (id: number) => {
    var rs: DonNgoaiGio = new DonNgoaiGio;
    await intance.post(ApiPaths.ngoaiGio.trinhNgoaiGio + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const layDangKyNgoaiGio = async (id: number) => {
    var rs: DonNgoaiGio = new DonNgoaiGio;
    await intance.get(ApiPaths.ngoaiGio.layDangKyNgoaiGio + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}


export const duyetDangKyNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.ngoaiGio.duyetDangKyNgoaiGio, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const thuHoiNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.ngoaiGio.thuHoiNgoaiGio + "?id=" + request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const layDanhSachDangKyNgoaiGio = async (nam: string) => {
    var rs: Array<ThongTinDonNgoaiGio> = new Array<ThongTinDonNgoaiGio>;
    await intance.get(ApiPaths.ngoaiGio.layDanhSachDangKyNgoaiGio + "?nam=" + nam)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const layDanhSachNguoiDuyet = async (nam: string) => {
    var rs: Array<ThongTinDonNgoaiGio> = new Array<ThongTinDonNgoaiGio>;
    await intance.get(ApiPaths.ngoaiGio.layDanhSachNguoiDuyet + "?nam=" + nam)
        .then((res) => {
            if (res.data.trangThai === responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw new Error(res.data.thongBao);
            }
        }).catch((err) => {
            throw err.message;
        });
    return rs;
}

export const layDanhSachTongHopTheoThang = async (request: TimKiemDonNgoaiGioRequest) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.ngoaiGio.layDanhSachTongHopTheoThang, {
        "start": 0,
        "length": 0,
        "filter": {
            "tuKhoa": request.tuKhoa,
            "ngayTaoTuNgay": request.ngayTaoTuNgay,
            "ngayTaoDenNgay": request.ngayTaoDenNgay,
            "ngayDangKyTuNgay": request.ngayDangKyTuNgay,
            "ngayDangKyDenNgay": request.ngayDangKyDenNgay,
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;

}

export const duaYKienDonNgoaiGio = async (request: any) => {
    await intance.post(ApiPaths.ngoaiGio.DuaYKien, request).then((res) => {
        if (res.data.trangThai === responseStatus.thanhCong) {
        } else {
            throw new Error(res.data.thongBao);
        }
    }).catch((err) => {
        throw 'Có lỗi xảy ra. Vui lòng thử lại';
    });
}

export const timKiemDonNgoaiGio = async (tuKhoa: string, nam: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.ngoaiGio.layDanhSachDonNgoaiGio, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": tuKhoa,
            "thoiGian": nam
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const timKiemDonNgoaiGioCaNhan = async (tuKhoa: string, nam: string, start: number, length: number) => {
    var data = {
        data: [],
        recordsTotal: 0,
    };
    await intance.post(ApiPaths.ngoaiGio.layDanhSachDonNgoaiGioCaNhan, {
        "start": start,
        "length": length,
        "filter": {
            "tuKhoa": tuKhoa,
            "thoiGian": nam
        }
    })
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
};

export const layChiTiet = async (id: number) => {
    var data = new DonNgoaiGio;
    await intance.get(ApiPaths.ngoaiGio.LayCT + "?id=" + id)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                data = res.data.duLieu;
            } else {
                throw res.data.thongBao
            }
        })
        .catch((err) => {
            throw err;
        });
    return data;
}

export const xoaDonNgoaiGio = async (id: number) => {
    await intance.get(ApiPaths.ngoaiGio.Xoa + "?id=" + id)
        .then(res => {
            if (res.data.trangThai != responseStatus.thanhCong) {
                throw new Error(res.data.thongBao);
            }
        })
        .catch(err => {
            throw err;
        });
}

export const layDanhSachDonNgoaiGioChoPheDuyet = async () => {
    var rs: any;
    await intance.get(ApiPaths.ngoaiGio.layDSDonNgoaiGioChoPheDuyet)
        .then((res) => {
            if (res.data.trangThai == responseStatus.thanhCong) {
                rs = res.data.duLieu;
            } else {
                throw Error(res.data.thongBao);
            }
        })
        .catch((err) => {
            throw err;
        });
    return rs;
}